import { apiClient } from "../apiClient";

export const KE_HOACH_KY_HIEU_ENDPOINT = "ke-hoach-ky-hieu";
export const keHoachKyHieuApi = {
  SelectAll: () => apiClient.get(`${KE_HOACH_KY_HIEU_ENDPOINT}`),
};
